export const server = process.env.VUE_APP_PACMNY_BE_PATH || "/pacmny-be/web/index.php";
export const domRoot = "";
